// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"35ac7b6a","926":"41925e22"}[chunkId] + ".chunk.css";
};